/**
 * Build metadata baked in at compile time.
 *
 * DEFAULT VALUES in git — these are what "dev / preview" web builds see.
 * On Appflow, `scripts/appflow-prebuild.sh` rewrites this file with real
 * git SHA + timestamp values just before `yarn build` runs, so the native
 * .ipa / .apk contains an unambiguous marker of exactly which commit was
 * compiled. Never trust the ASC "version" field alone — this is the
 * ground truth.
 *
 * DO NOT commit anything but the defaults. Appflow's rewrite is
 * intentionally not staged, and the working-tree change is discarded
 * when the build container is torn down.
 */
export const BUILD_ID = "dev";
export const BUILD_DATE = "";
